import React from 'react';
import {useRouteMatch} from "react-router-dom";
import PropTypes from 'prop-types';
import search from '../../assets/search-4A4A4A.svg'
import ButtonCommon from "../ButtonCommon";
import mime from "mime-types";
import {pathnames as P} from "../../constants/pathnames";
import {errors as E} from "../../constants/errors";
import styles from './styles.module.scss';

const ViewFile = ({
                    fileTypeID,
                    fileList,
                    getFile,
                    showGlobalErrorMessage
                  }) => {
  const {params: {shumaId}} = useRouteMatch(P.INSPECTION_AND_FORM_IDS);
  const [file] = Array.isArray(fileList) ? fileList.filter(item => item.fileTypeID === fileTypeID) : [];
  const fileExtension = file ? file.fileExtension : '';
  const fileID = file ? file.fileID : 0;

  const getType = () => {
    switch (mime.lookup(fileExtension)) {
      case 'application/pdf':
        return 'pdf';
      case 'image/gif':
      case 'image/jpeg':
      case 'image/jpg':
      case 'image/tiff':
      case 'image/png':
        return 'image';
      default:
        return null;
    }
  };

  const updateFile = async () => {
    try {
      const body = await getFile({shumaId, fileID});
      const mimeType = mime.lookup(fileExtension);
      return `data:${mimeType};base64,${body}`;
    } catch (e) {
      console.error(e)
    }
  };

  const handleOpen = () => {
    if (getType()) {
      Promise.resolve()
        .then(updateFile)
        .then((content) => {
          if (content) {
            let file = getType() === 'image'
              ? '<img src="' + content + '">'
              : '<iframe width="100%" height="100%" src="' + content + '"></iframe>'
            let popup = window.open();
            popup.document.write(file);
          } else {
            showGlobalErrorMessage(E.FILE_NOT_FOUND)
          }
        })
        .catch((e) => {
          console.error(e);
        })
    }
  };

  return (
    <ButtonCommon
      variant={'submit'}
      icon={search}
      customContainerStyles={styles.container}
      customIconStyles={styles.icon}
      onClick={() => {
        handleOpen();
      }}
    />
  )
};

ViewFile.propTypes = {
  shumaId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  fileID: PropTypes.number,
  fileList: PropTypes.array,
};

export default ViewFile;
